export const GET_ADMIN_USER_DATA = " GET_ADMIN_USER_DATA";
export const VERIFY_LOADING = "VERIFY_LOADING";
export const VERIFY_ERROR = "VERIFY_ERROR";
export const UPLOAD_PIC="UPLOAD_PIC";